const TEXT_SIZES = { "text-lg": "lg", "text-base": "base", "text-sm": "sm", "text-xs": "xs" };

export const getTextSize = (value) => TEXT_SIZES[value] || "base";
